<template>
  <TitledInputField :inputLabel="inputLabel" :iconName="iconName">
    <template #inputComponent>
      <ThemedSelector
        :items="items"
        :value="value"
        @change="onChange"
        outlined
        height="32"
        class="mt-2 small-height"
        density="compact"
        hide-details="auto"
        persistent-placeholder
        auto-select-first
        no-data-text="Select an item"
        return-object
        cache-items
        append-icon="none"
      />
    </template>
  </TitledInputField>
</template>

<script>
import TitledInputField from "./TitledInputField.vue";
import ThemedSelector from "../../../core/ThemedSelector.vue";
export default {
  name: "TitledSelectionField",
  components: {
    TitledInputField,
    ThemedSelector,
  },
  props: {
    inputLabel: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    iconName: {
      type: String,
      default: "mdi-windsock", // Default icon
    },
    items: {
      type: Array,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>
